function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
const chipVariants = cva('inline-flex items-center rounded-full border text-sm font-medium select-none transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2', {
    variants: {
        variant: {
            default: '',
            outline: 'bg-transparent'
        },
        color: {
            default: 'bg-primary/10 text-primary border-primary/20',
            brand: 'bg-brand-950 text-brand-300 border-brand-800',
            success: 'bg-turquoise-900 text-turquoise-300 border-turquoise-700',
            warning: 'bg-orange-950 text-orange-300 border-orange-800',
            error: 'bg-error-600/20 text-error-400 border-error-600/40',
            secondary: 'bg-gray-900 text-gray-300 border-gray-800'
        },
        size: {
            sm: 'px-2 py-1 text-xs font-normal',
            md: 'px-3 py-1.5'
        },
        disabled: {
            true: 'opacity-50 cursor-not-allowed',
            false: ''
        }
    },
    defaultVariants: {
        variant: 'default',
        color: 'default',
        size: 'md',
        disabled: false
    }
});
export function Chip(_0) {
    let { label, onRemove, variant = 'default', color = 'default', size = 'md', disabled = false, className } = _0, props = _object_without_properties(_0, [
        "label",
        "onRemove",
        "variant",
        "color",
        "size",
        "disabled",
        "className"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, props), {
        className: cn(chipVariants({
            variant,
            color,
            size,
            disabled
        }), className),
        children: [
            /*#__PURE__*/ _jsx("span", {
                children: label
            }),
            onRemove && !disabled && /*#__PURE__*/ _jsx("button", {
                type: "button",
                onClick: onRemove,
                className: "ml-1 rounded-full p-0.5 hover:bg-primary/10 focus-visible:ring-1 focus-visible:ring-ring",
                children: /*#__PURE__*/ _jsx(X, {
                    className: "h-3.5 w-3.5"
                })
            })
        ]
    }));
}
